export default function getResource(label, vars = []) {
    const resources = {
        orderNumber: 'Order No'
    };
    return resources[label];
}
